<template>
  <div id="app">
    <router-view v-if="isShow" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.pageReload,
    };
  },
  data() {
    return {
      isShow: true,
    };
  },
  methods: {
    getToken() {
      if (this.$route.path != "/") {
        if (localStorage.getItem("token")) {
        } else {
          this.api.user.getToken().then((res) => {
            if (res.data != this.user.token) {
              this.$message.success("登录失效，请重新登录");
              this.logout();
            }
            localStorage.setItem("token", this.user.token);
          });
        }
      }
    },
    logout() {
      if (JSON.parse(localStorage.getItem("user")) != null) {
        this.api.logout({}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.$store.commit("signOut");
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        // alert(1);
        this.$store.commit("signOut");
        this.$router.push({ path: "/" });
      }
    },
    pageReload() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  mounted() {
    if (this.$route.path != "/") {
      this.$store.dispatch("getAuthList");
    }
    this.$store.dispatch("getCurrentUser");
    // if (this.$store.state.isLogin === false) {
    //   this.$router.push("/")
    //   return
    // }
    let lastRouter = localStorage.getItem("lastRouter");
    // if (lastRouter) {
    //   this.$router.push(lastRouter)
    // }
    this.getToken();
  },
  watch: {
    $route: function (to, from) {
      // console.log("to",to)
      // if(to.path == "login"){
      //   this.$store.commit("signOut");
      // }
      // console.log("to",to)
      // console.log("from",from)
      localStorage.setItem("lastRouter", to.fullPath);
      localStorage.setItem("lastRouterName", to.name);
    },
    isLogin(val, oldVal) {
      if (val) {
        this.$router.push(this.$route.query.redirect || "/main");
      } else {
        this.$router.push({ name: "login" });
        // this.$router.replace({
        //   path: "/login",
        //   query: {
        //     redirect: this.$router.currentRoute.fullPath
        //   }
        // });
      }
    },
  },
};
</script>

<style>
html,
body,
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0px;
  background-color: rgb(246, 249, 250);
}
.pointer {
  cursor: pointer;
}
.expandClick {
  display: inline-block;
  padding: 10px 35px;
  cursor: pointer;
}
</style>
<style lang="less">
@import url("../static/css/mathquill.less");
@import url("../static/css/jdmath.less");
@import url("../static/css/clf.less");
</style>



// WEBPACK FOOTER //
// src/App.vue